import { GetServerSidePropsContext, NextPage } from 'next';
import Meta from '../../../components/Meta';
import { metaTags } from '../../../components/_dummyData';
import { useBreadcrumbs } from '../../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import type { ServicesTab } from '../../../components/Services/Services.type';
import { Services } from '../../../components/Services/Services';

const ServicesPage: NextPage<
    Awaited<ReturnType<typeof getServerSideProps>>['props']
> = ({ activeTab }) => {
    useBreadcrumbs([{ title: 'Сервисы' }]);

    return (
        <>
            <Meta
                title={metaTags.services.title}
                description={metaTags.services.description}
                url={metaTags.services.url}
            />
            <Services activeTab={activeTab} />
        </>
    );
};

export default ServicesPage;

export const getServerSideProps = async (
    context: GetServerSidePropsContext
) => {
    const activeTab = (context.query.slug || 'licenses') as ServicesTab['name'];

    return {
        props: {
            activeTab,
        },
    };
};
